import React, { FC }            from "react";
import { useDrag }              from "react-dnd";
import { useDispatch }          from "react-redux";
import { Button, Card, Input }  from "semantic-ui-react";
import RecordTemplateRepository from "../../../../../domain/record/template/RecordTemplateRepository";
import WidgetTitle              from "../../../../../domain/record/widget/WidgetTitle";
import WidgetType               from "../../../../../domain/record/widget/WidgetType";
import RecordTemplateDataSource
                                from "../../../../../infrastructure/datasource/record/template/RecordTemplateDataSource";
import WidgetProps              from "../WidgetProps";

const DropAreaImageSmallWidget: FC<WidgetProps> = (props: WidgetProps) => {
  const repository: RecordTemplateRepository = new RecordTemplateDataSource(useDispatch());
  const [{isDragging}, drag] = useDrag({
    item: {widgetIndex: props.widgetIndex, type: WidgetType.IMAGE_SMALL},
    collect: monitor => ({isDragging: monitor.isDragging()})
  });

  const {widgetIndex, widget} = props;
  return (
    <>
      <div
        ref={ drag }
        style={ {
          opacity: isDragging ? 0.5 : 1,
          cursor: "move",
          position: "absolute",
          left: widget.coordinate.x + "px",
          top: widget.coordinate.y + "px"
        } }
      >
        <Card style={ {width: "318px"} }>
          <Card.Content>
            <Card.Header>
              <Input
                style={ {height: "33.5px", width: "242px"} }
                defaultValue={ widget.title.value }
                onChange={ (event, data) => repository.setWidgetTitle(widgetIndex, new WidgetTitle(data.value)) }
                placeholder="タイトルを入力"
              />
              <Button
                style={ {height: "33.5px", marginLeft: "5px"} }
                icon="close"
                onClick={ () => repository.deleteWidget(widgetIndex) }
              />
            </Card.Header>
            <div
              style={ {height: "120px", backgroundColor: "#E9ECEF", outline: "darkgray dashed 2px"} }
            >
              <p>ここに写真を表示することができます。</p>
            </div>
          </Card.Content>
        </Card>
      </div>
    </>
  );
};

export default DropAreaImageSmallWidget;
